import { getCurrentDateWithDashFormatting} from './getCurrentDateWithDashFormatting';
import { formatDate } from './formatDate';

export {getCurrentDateWithDashFormatting, formatDate};